import Seo from "../lib/Seo";
import useReveal from "../lib/useReveal";
import { JoinForm } from "../components/JoinForm";

const TOPICS = [
  { t: "Why the first tee feels different", d: "What actually changes in your body when people are watching — and why your range swing stays on the range." },
  { t: "What one bad shot does to your system", d: "The stress response behind the spiral, and why 'just forget about it' rarely works." },
  { t: "Why your best rounds feel like nothing", d: "What golfers describe when the noise drops — and what the research says about that state." },
  { t: "The back-nine fade", d: "Attention is a resource, not a choice. Why concentration runs out and what affects how fast." },
];

export default function TheScience() {
  useReveal();
  return (
    <>
      <Seo
        title="The Science · Weekly | Dialed In"
        description="One email a week on stress, focus, attention and the golfer behind the swing. Plain English, real research, no exaggerated claims. Free."
      />
      <section className="page-head" data-testid="science-page">
        <div className="wrap">
          <div className="label rv rv-up">The Science &middot; Weekly</div>
          <h1 className="disp page-h rv rv-up">The science behind <span className="g">the golfer.</span></h1>
          <p className="page-sub rv rv-up">
            One email a week on stress, focus, attention and what actually shapes a round — written in plain English by Jason, for golfers. No jargon. No miracle claims. Just what the research says and what it might mean for your game.
          </p>
        </div>
      </section>

      <section className="sec sec-2" data-testid="science-what">
        <div className="wrap">
          <div className="label rv rv-up">What you'll get</div>
          <div className="moments" style={{ marginTop: "4vh" }}>
            <div className="moment-row rv rv-up">
              <div className="moment-name"><span className="moment-dot" style={{ background: "var(--c-prepare)" }} />Weekly</div>
              <p className="moment-copy">One short, honest read each week. The science of stress, attention and performance — translated for the course, never oversold.</p>
            </div>
            <div className="moment-row rv rv-up">
              <div className="moment-name"><span className="moment-dot" style={{ background: "var(--c-reset)" }} />Research</div>
              <p className="moment-copy">What golfers are telling us in the research, and the patterns showing up behind the swing.</p>
            </div>
            <div className="moment-row rv rv-up">
              <div className="moment-name"><span className="moment-dot" style={{ background: "var(--c-sustain)" }} />The build</div>
              <p className="moment-copy">Product development as it happens — Prepare first, then Reset, Sustain and Recover. Decisions, setbacks and all.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="sec" data-testid="science-topics">
        <div className="wrap">
          <div className="label rv rv-up">The kind of thing we cover</div>
          <div className="moments" style={{ marginTop: "4vh" }}>
            {TOPICS.map((topic, i) => (
              <div className="moment-row rv rv-up" key={i} data-testid={`science-topic-${i + 1}`}>
                <div className="moment-name" style={{ fontSize: "clamp(18px, 2vw, 24px)" }}>
                  <span className="moment-dot" style={{ background: "var(--gold)" }} />No. {String(i + 1).padStart(2, "0")}
                </div>
                <div>
                  <div className="moment-when">{topic.t}</div>
                  <p className="moment-copy">{topic.d}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="form-fine rv rv-up" style={{ marginTop: "4vh" }}>
            Example topics. The Science &middot; Weekly shares research and ideas — it is not medical advice and makes no medical claims.
          </p>
        </div>
      </section>

      <section className="sec sec-2" data-testid="science-join">
        <div className="wrap">
          <div className="join-grid">
            <div>
              <div className="label rv rv-up">Free, every week</div>
              <h2 className="disp join-h rv rv-up">Get The Science <span className="g">&middot; Weekly.</span></h2>
              <p className="join-sub rv rv-up">Join Dialed In and it arrives every week. Reply to any issue — it goes straight to Jason.</p>
            </div>
            <div className="rv rv-up">
              <JoinForm
                idPrefix="science"
                buttonLabel="Join Dialed In"
                eventName="science_signup"
                consent="Join Dialed In and receive The Science · Weekly, golfer research, product-development updates and early access. Unsubscribe at any time."
                tyBody="Welcome to The Science · Weekly. The next issue lands in your inbox soon — hit reply on any of them, Jason reads every one."
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
